import {
  Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.score,
    borderRadius: 10,
    margin: theme.spacing(0, 3),
  },
  cardContent: {
    color: theme.palette.text.default,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContentText: {
    fontFamily: 'Raleway',
    textAlign: 'center',
  },
}));
function ScoreCard({ score, textCard }) {
  const classes = useStyles();
  return (
    <Card className={classes.card} elevation={0}>
      <CardContent className={classes.cardContent}>
        <Typography className={classes.cardContentText}>{score}</Typography>
        <Typography className={classes.cardContentText}>{textCard}</Typography>
      </CardContent>
    </Card>
  );
}

export default ScoreCard;

ScoreCard.propTypes = {
  score: PropTypes.number.isRequired,
  textCard: PropTypes.string.isRequired,
};
